import axios from 'axios'
import CONFIG from './config'
import errorUtils from '@/utils/errorUtils'
import paramsInterceptor from '../interceptors/params'
import signatureInterceptor from '../interceptors/signature'
import { onResponse as serverTimeOnResponse, onResponseError as serverTimeOnResponseError } from '../interceptors/server-time'
import { TOKEN_KEY, getToken, setToken } from '@/utils/auth'
axios.interceptors.request.use((config) => paramsInterceptor(config))
// 前後端簽名校驗：為請求附加 X-Api-Key / X-Timestamp / X-Nonce / X-Signature
axios.interceptors.request.use((config) => signatureInterceptor(config))
// 簽名用的 X-Timestamp 取後端回應頂層的 serverTime（後端要求，不要前端自己生成）
// 失敗的回應同樣帶 serverTime：401/403 且校準到伺服器時間時，用新的時間戳與新的 nonce 重試一次
axios.interceptors.response.use(
  (response) => serverTimeOnResponse(response),
  (error) => serverTimeOnResponseError(error, (config) => axios(config)),
)
// axios.defaults.withCredentials = true

class ApiManager {
  /**o
   * 網路請求：GET方法
   * @param {Object} data 傳入資料(url, params, header ···)
   */
  get(data) {
    data.method = 'get'
    return this._sendRequest(data)
  }

  /**
   * 網路請求：POST方法
   * @param {Object} data 傳入資料(url, params, header ···)
   */
  post(data) {
    data.method = 'post'
    return this._sendRequest(data)
  }

  put(data) {
    data.method = 'put'
    return this._sendRequest(data)
  }

  delete(data) {
    data.method = 'delete'
    return this._sendRequest(data)
  }


  _sendRequest(data) {
    let config = Object.assign({}, CONFIG); //一定要複製一個,避免汙染全域性物件
    config.headers = data.headers ? data.headers : config.headers;
    config.headers[TOKEN_KEY] = getToken();
    config.method = data.method;
    config.url = data.url;
    config.body = data.params; //引數由攔截器分配,具體程式碼在 src/interceptors/params.js
    // 單個介面可傳 signature: true/false 覆蓋簽名校驗（見 src/api/interceptors/signature.js）
    config.signature = data.signature;
    axios.defaults.withCredentials = true;

    return axios(config).then(res => this.onSuccess(res)).catch(err => this.onFailure(err));
  }

  onSuccess(response) {
    
    setTimeout(()=>{
    },500)
    const result = response.data;
    const token = response.headers[TOKEN_KEY];
    if(token){
      setToken(token)
    }
    if (result && result.code == 0) {
      return Promise.resolve(result);
    }
    //處理業務錯誤
    const apiError = errorUtils.parseErrorFromResult(response);
    if (apiError.code === 1) {  // 如果登入過期了或者未登入則跳轉到登入頁面。
    }
    return Promise.reject(apiError);
  }

  onFailure(error) {
    // errorUtils.showError(error);
    if (error.type) {
      /**
       * 如果error知道了確切的型別,表明是從onSuccess
       * 的Promise reject過來的,因此不需要再次判斷錯誤型別
       */
      return Promise.reject(error)
    }

    //處理網路錯誤
    const networkError = errorUtils.parseError(error);
    return Promise.reject(networkError);
  }
}

export default new ApiManager()
